/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  conversationTransferStatus(agentId, params = {}) {
    return axios.get(`${this.url}/${agentId}/conversation_transfer_status`, {
      params,
    });
  }

  transferConversations(agentId, params = {}) {
    return axios.post(`${this.url}/${agentId}/transfer_conversations`, params);
  }
}

export default new Agents();
